import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20cozy%20reading%20nook%20with%20warm%20amber%20and%20coral%20toned%20gradient%20background%2C%20soft%20abstract%20geometric%20shapes%2C%20modern%20minimalist%20design%2C%20warm%20lighting%2C%20comfortable%20atmosphere%2C%20creative%20and%20artistic%20composition%2C%20no%20text%2C%20no%20people%2C%20abstract%20background&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
          alt="韩漫网 - 免费韩漫在线阅读"
          className="w-full h-full object-cover"
          title="韩漫网 - 免费韩漫大全 好看的韩国漫画 韩漫在线观看"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight">
          免费韩漫大全
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-background-200 max-w-2xl mx-auto leading-relaxed">
          海量好看的韩国漫画，尽在韩漫网。覆盖恋爱、奇幻、动作、搞笑等全部分类，
          每日更新，免费畅读，韩漫在线观看首选平台。
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/recommend"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line mr-2"></i>
            热门推荐
          </Link>
          <Link
            to="/category/recommend"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-semibold rounded-full border border-background-50/30 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-compass-line mr-2"></i>
            发现更多
          </Link>
        </div>

        <div className="mt-10 md:mt-12 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">200+</div>
            <div className="text-xs md:text-sm text-background-300 mt-1">漫画作品</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">12</div>
            <div className="text-xs md:text-sm text-background-300 mt-1">分类板块</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">50万+</div>
            <div className="text-xs md:text-sm text-background-300 mt-1">忠实读者</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}